import { useContext } from 'react';
import ThemeContext from '../../store/theme-context';
import Contact from '../Contact/Contact';


const ContactSection = () => {
    const theme = useContext(ThemeContext);
    return ( 
        <Contact/>
     );
}
 
export default ContactSection;